import React from 'react';

import { Flex } from '@vimeo/bokeh';
import { Checkmark, CloseX } from '@vimeo/bokeh-icons';
import { ButtonToggleStateBokeh, StaffPickBadge } from '@vimeo/components';
import { translate } from '@vimeo/i18n-runtime';

import UsernameAndAvatar from './UsernameAndAvatar';
import { UploaderDetailsType } from '../../types';

function UploaderDetails({
  user,
  videoId,
  isFollowing,
  isLoadingFollow,
  onFollowClick,
  onProfileClick,
  onProfileMouseOver,
  showByline,
  showCard,
  showFollow,
  showProfile,
  showProfileLink,
  extraActions,
}: UploaderDetailsType) {
  if (!user) {
    return null;
  }

  return (
    <Flex data-testid="uploader-details" align="center" gap="75">
      <UsernameAndAvatar
        user={user}
        showByline={showByline}
        showCard={showCard}
        showProfile={showProfile}
        showProfileLink={showProfileLink}
        onProfileClick={onProfileClick}
        onProfileMouseOver={onProfileMouseOver}
      />
      {user.isStaffPicked && showProfile && showByline && (
        <Flex gap={10}>
          <StaffPickBadge
            href="/watch"
            videoId={parseInt(videoId)}
            userUri={user.uri}
            feature="profile"
          />
        </Flex>
      )}
      {showFollow ? (
        <ButtonToggleStateBokeh
          isDisabled={isLoadingFollow}
          isActive={isFollowing}
          offStateText={translate('Follow')}
          onClick={onFollowClick}
          onIcon={<Checkmark />}
          onStateText={translate('Following')}
          turnOffActionText={translate('Unfollow')}
          turnOffIcon={<CloseX />}
          size="xs"
        />
      ) : null}
      {extraActions}
    </Flex>
  );
}

export { UploaderDetails };
